export const PREFIX = "daily-gift";
